import LegalShell, { Section } from "@/components/LegalShell";

// Optional founder photo placeholder — Praveen can drop a real image into
// /app/frontend/public/founder.jpg later and uncomment the <img> below.
export default function AboutPage() {
  return (
    <LegalShell testid="about-page" eyebrow="about" title="About">
      <Section heading="The book this platform is built on">
        <p>
          The Founder Mode Quest is built on the book{" "}
          <em className="text-zinc-200">
            The Founder Mode: Escape 9 to 5, Find Problem-Solution Fit & Scale to
            $10 Million in 3 Years
          </em>{" "}
          by Praveen Singh V — a 35-chapter playbook for bootstrappers,
          employees-turned-founders, and anyone trying to ship something real
          instead of reading about it.
        </p>
      </Section>

      <Section heading="What is The Founder Mode Quest?">
        <p>
          13 AI-powered quests, each a Socratic dialogue with a GPT-4o mentor
          trained on the book. The mentor doesn&apos;t lecture — it asks. It pushes
          back on shallow answers, probes for specifics, and scores your responses
          across five founder dimensions: clarity, problem-solution fit, empathy,
          growth, and execution.
        </p>
        <p>
          By the end of Quest 12, you have a personalized founder roadmap — not a
          generic course completion certificate, but a written record of how your
          thinking evolved across every dimension that matters.
        </p>
      </Section>

      <Section heading="Who is this for?">
        <ul className="list-disc pl-6 space-y-1 marker:text-amber-400">
          <li>
            <strong className="text-zinc-200">Bootstrappers</strong> who&apos;ve
            been &ldquo;thinking about it&rdquo; for six months
          </li>
          <li>
            <strong className="text-zinc-200">Senior PMs, engineers, designers</strong>{" "}
            ready to escape 9-5 but unsure what to build
          </li>
          <li>
            <strong className="text-zinc-200">College student founders</strong>{" "}
            who want a framework, not advice tweets
          </li>
          <li>
            <strong className="text-zinc-200">Serial entrepreneurs</strong> who
            need a sharper, ego-free mirror before round 2
          </li>
        </ul>
      </Section>

      <Section heading="About the founder">
        <div className="flex flex-col sm:flex-row sm:items-start gap-6">
          <img
            data-testid="founder-photo"
            src="/founder.jpg"
            alt="Praveen Singh V, founder of Super Founder Hub"
            loading="lazy"
            className="w-40 h-40 sm:w-48 sm:h-48 rounded-full object-cover border-2 border-amber-500/40 shadow-lg shadow-amber-500/10 shrink-0"
          />
          <p className="min-w-0">
            <strong className="text-zinc-200">Praveen Singh V</strong> is the
            author of <em>The Founder Mode</em> and the founder of Super Founder
            Hub. He is based in Bangalore, India.
          </p>
        </div>
      </Section>

      <Section heading="The company">
        <p>
          <strong className="text-zinc-200">Super Founder Hub</strong> is a sole
          proprietorship building digital products for early-stage founders. The
          Founder Mode Quest is its first product.
        </p>
        <ul className="list-none pl-0 space-y-1 text-zinc-300">
          <li>Super Founder Hub</li>
          <li>Kanapura Main Road</li>
          <li>Bangalore, Karnataka, India</li>
        </ul>
      </Section>
    </LegalShell>
  );
}
